import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import { L10n } from "@syncfusion/ej2-base";
import { useEffect, useRef, useCallback } from "react";
import {
  ColumnsDirective,
  ColumnDirective,
  Page,
  Toolbar,
  Edit,
  Inject,
  Filter,
  VirtualScroll,
  Sort,
  DetailRow,
  Selection,
  ColumnChooser,
  Group,
} from "@syncfusion/ej2-react-grids";
import { companyInvitedUsersService } from "../../../../../services/dataManager";
import css from "./index.module.css";
import GridComponent from "../../../../../cubeComponent/html/grid";
import ButtonComponent from "../../../../../cubeComponent/form/ButtonComponent";
import axiosWrapper from "../../../../../services/axiosWrapper";
import { TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "../../../../../services/constants";
import { showToastNotification } from "../../../../../actions/toast";
import { useDispatch, useSelector } from "react-redux";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ReactDOM from "react-dom/client";
import { convertDate } from "../../../../../services/luxonHelper";
import Forbidden from "@Pages/Error/Forbidden";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";

function PendingUsers() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const portalSettingInfo = useSelector((state) => state.portalSettingInfo);
  const getUserAvatar = ({ id }) => {
    return <UserNameTagComponent id={id} />;
  };

  L10n.load({
    "en-US": {
      grid: {
        AddFormTitle: "Create New Department",
        EditFormTitle: "Edit  ",
        CancelButton: "Discard",
        ConfirmDelete: "Are you sure you want to Delete ?",
      },
    },
  });

  useEffect(() => {
    document.title = t("Portal Settings | Portal Users");
  }, []);

  const pageSettings = { pageSizes: true, pageSize: 10 };

  const editSettings = {
    allowAdding: true,
    allowDeleting: true,
    mode: "Dialog",
    showDeleteConfirmDialog: true,
  };

  const dataGrid = useRef();

  const handleResendInvitaionClick = async (e) => {
    e.stopPropagation();
    const userId = e.currentTarget.attributes["data-id"].value;

    const response = await axiosWrapper.post(`${getBackendUrl()}/accounts/resendUserInvitationLink`, {
      userId,
    });

    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("Invitation sent successfully"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: response.data.message || "",
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
  };

  const queryCellInfo = (args) => {
    if (args.column.field === "lastInviteDate") {
      ReactDOM.createRoot(args.cell).render(convertDate(Number(args.data.lastInviteDate), "dateForText"));
    }
  };

  const resendInvitationTemplate = (args) => (
    <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} data-id={args.id} onClick={handleResendInvitaionClick}>
      {t("Resend Invite")}
    </ButtonComponent>
  );

  const pendingUsersList = useCallback(
    () => (
      <div className={css.controlPane}>
        <GridComponent
          ref={dataGrid}
          dataSource={companyInvitedUsersService}
          editSettings={editSettings}
          filterSettings={{
            type: "Menu",
          }}
          allowFiltering
          allowSorting
          allowPaging
          height="100%"
          className={css.tableWrapper}
          allowGrouping={false}
          rowHeight={48}
          pageSettings={pageSettings}
          queryCellInfo={queryCellInfo}
        >
          <ColumnsDirective>
            <ColumnDirective field="checkbox" type="checkbox" allowSorting={false} allowFiltering={false} width="30" />
            <ColumnDirective
              field="userName"
              headerText={t("Name")}
              width="120"
              textAlign="Left"
              // filter={Filter}
              template={getUserAvatar}
            />
            <ColumnDirective field="email" headerText={t("Email")} width="120" textAlign="Left" filter={Filter} />
            <ColumnDirective
              field="lastInviteDate"
              headerText={t("Last Invite Date")}
              width="180"
              textAlign="Left"
              // filter={Filter}
              type="date"
              allowEditing={false}
            />
            <ColumnDirective
              headerText=""
              width="180"
              template={resendInvitationTemplate}
              textAlign="Left"
              allowEditing={false}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Page,
              DetailRow,
              Toolbar,
              Edit,
              Filter,
              Sort,
              Group,
              ColumnChooser,
              Selection,
              ColumnChooser,
              VirtualScroll,
            ]}
          />
        </GridComponent>
      </div>
    ),
    [portalSettingInfo],
  );

  return <>{!portalSettingInfo?.portalUsers?.isVisible ? <Forbidden /> : pendingUsersList()}</>;
}

export default PendingUsers;
